<script lang="ts">
	import HeaderMenu from './HeaderMenu.svelte';
</script>

<nav class="p-4">
	<HeaderMenu />
</nav>

<style>
	nav {
		display: flex;
		justify-content: space-between;
	}
</style>
